import React from 'react'

import { DialogConfirmation } from 'app/KinerjaPSPegawaiPage/components/DialogConfirmation'

type TDialogExitPreventionProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}
export const DialogExitPrevention: React.FC<TDialogExitPreventionProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <DialogConfirmation
      isOpen={isOpen}
      autoFocus={false}
      returnFocus={false}
      size="sm"
      title="Simpan sebelum keluar?"
      description="Pilihan Anda akan disimpan dan masih dapat diubah selama Perencanaan belum diajukan."
      ctaConfirm="Simpan dan keluar"
      onClickConfirm={onConfirm}
      onClickCancel={onClose}
    />
  )
}
